interface Props {
  loading: boolean;
}

export default function NoDataRow({ loading }: Props) {
  return loading
    ? (
      <tr className='text-center'>
        <td colSpan={9}>
          <div className='spinner-border' role='status'>
            <span className='visually-hidden'>Loading...</span>
          </div>
        </td>
      </tr>
      )
    : (
      <tr>
        <td
          colSpan={9}
          className='text-center global-text align-middle '
          style={{ color: ' #979797                      ' }}
        >
          Fuel Surcharge not found! Please try again.
        </td>
      </tr>
      );
}
